(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
                .state('app', {
                    abstract: true,
                    resolve: {
                        translatePartialLoader: ['$translatePartialLoader', function ($translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('tooltip');
                                $translatePartialLoader.addPart('favorites');
                            }]
                    }
                })
                .state('app.private', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: 'app/shared/layout/main/main.html'
                        },
                        'navbar@app.private': {
                            templateUrl: 'app/shared/layout/navbar/navbar.html',
                            controller: 'NavbarController',
                            controllerAs: 'vmNavbar'
                        }
                    }
                })
                .state('app.public', {
                    abstract: true
                })
    }
})();
